import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u4E2D\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { ArrowRight } from '@element-plus/icons-vue';
import { getMediaReportsDetail_url } from "@/api"; //引入发送请求获取数据的方法

import { useRouter, useRoute } from "vue-router";
import { h } from 'vue';
import { ElMessage } from 'element-plus';
import { onMounted, ref, reactive, computed } from 'vue';
export default {
  components: {},
  name: 'Report',
  setup: function setup() {
    var reportsDetail = ref({});
    var previousReports = ref({});
    var nextReports = ref({});
    var pdfUrl = ref('');
    var route = useRoute();
    var reportId = route.query.reportId; //路由获取详情id

    onMounted(function () {
      getHomeTopMediaReportsList(reportId);
    });

    var getHomeTopMediaReportsList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  reportId: id
                };
                _context.next = 3;
                return getMediaReportsDetail_url(params);

              case 3:
                res = _context.sent;
                // console.log(res,'媒体报道详情');
                reportsDetail.value = res.data.reportsDetail;
                previousReports.value = res.data.previousReports;
                nextReports.value = res.data.nextReports;
                pdfUrl.value = res.data.pdfUrl || '';
                console.log('reportsDetail.value=', reportsDetail.value);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getHomeTopMediaReportsList(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var getReports = function getReports(report) {
      if (report.jumpFlag == 1) {
        window.open(report.jumpUrl);
      }

      if (!report.reportId) {
        ElMessage('暂无更多');
        return;
      }

      console.log('report=', report);
      console.log('report.jumpFlag=', report.jumpFlag);
      console.log('report.reportId=', report.reportId); // return  

      var url = "https://www.tenacia.com/mediaDetails?reportId=".concat(report.reportId); // let url = `https://webtest.tenacia.com/mediaDetails?reportId=${report.reportId}`

      window.open(url); // getHomeTopMediaReportsList(reportId)
    };

    var openPdf = function openPdf() {
      var _reportsDetail$value;

      var url = pdfUrl.value || ((_reportsDetail$value = reportsDetail.value) === null || _reportsDetail$value === void 0 ? void 0 : _reportsDetail$value.pdfUrl);

      if (!url) {
        ElMessage('暂无PDF链接');
        return;
      }

      window.open(url);
    };

    var hasPdfUrl = computed(function () {
      var _reportsDetail$value2;

      return !!(pdfUrl.value || (_reportsDetail$value2 = reportsDetail.value) !== null && _reportsDetail$value2 !== void 0 && _reportsDetail$value2.pdfUrl);
    });
    return {
      reportsDetail: reportsDetail,
      previousReports: previousReports,
      nextReports: nextReports,
      getReports: getReports,
      openPdf: openPdf,
      hasPdfUrl: hasPdfUrl
    };
  }
};